import React from 'react'
import { motion } from "framer-motion"
import { useEase } from "../motion"

export const TitleTesting = (props) => {

	const parentControl = {
		closed: {
			opacity: 1,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 1,
			},
		},
		open: {
			opacity: 1,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 1.5,
				delayChildren: 1.35,
				staggerChildren: 0.1,
				when: "afterChildren",
			},
		},
	}

	const leftVar = {
		closed: {
			x: "-20vw",
			opacity: 0,
			transition: {
				duration: 0.4,
			}
		},
		open: {
			x: 0,
			opacity: 1,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 0.75,
			},
		},
	}

	const rightVar = {
		closed: {
			opacity: 0,
			x: "20vw",
		},
		open: {
			opacity: 1,
			x: 0,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 0.75,
			},
		},
	}

   return (
		<div className="chapter-title">
			<motion.svg
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				viewBox="0 0 326.3 317.28"
				variants={parentControl}
				initial="closed"
				animate={props.coverLoaded ? "open" : "closed"}
				exit="closed"
			>
				<defs>
					<clipPath id="clipPath" transform="translate(-5.96 -9.15)">
						<rect x="16" width="306" height="41" fill="none" />
					</clipPath>
					<clipPath
						id="clipPath-2"
						transform="translate(-5.96 -9.15)"
					>
						<rect y="50" width="338" height="84" fill="none" />
					</clipPath>
					<clipPath
						id="clipPath-3"
						transform="translate(-5.96 -9.15)"
					>
						<rect
							x="9"
							y="156"
							width="326"
							height="62"
							fill="none"
						/>
					</clipPath>
					<clipPath
						id="clipPath-4"
						transform="translate(-5.96 -9.15)"
					>
						<rect
							x="35"
							y="230"
							width="276"
							height="102"
							fill="none"
						/>
					</clipPath>
				</defs>
				<g id="testing">
					<g id="group_bu">
						<g clipPath="url(#clipPath)">
							<motion.g
								id="bu_launches"
								className="isolation"
								variants={leftVar}
							>
								<g className="isolation">
									<path
										d="M47.25,28.48c0,6.94-6.09,6.94-11,6.94H27.74V10.23h7.59c4.61,0,10.58,0,10.58,6.19A5.3,5.3,0,0,1,42,21.82,6.74,6.74,0,0,1,47.25,28.48Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M53.69,23.44V10.23h9.15V26.64h2.69V10.23h9.15V23.44c0,4.28,0,12.38-10.48,12.38S53.69,27.72,53.69,23.44Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M113.63,26.57v8.85H95.56V10.23h9V26.57Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M132.53,9.15l13.35,26.27h-26.7Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M150.06,23.44V10.23h9.15V26.64h2.7V10.23h9.14V23.44c0,4.28,0,12.38-10.48,12.38S150.06,27.72,150.06,23.44Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M200.6,10.23V35.42h-22V9.58l13,12.81V10.23Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M207.27,22.86c0-7.78,5.4-13.07,13.32-13.07a13.35,13.35,0,0,1,7.95,2.63l-4.71,7.85a5,5,0,0,0-3.21-1.19,3.72,3.72,0,0,0-4,3.71,3.61,3.61,0,0,0,3.93,3.78,5.36,5.36,0,0,0,3.56-1.3l4.39,7.92a13.36,13.36,0,0,1-8.31,2.66C212.59,35.85,207.27,30.67,207.27,22.86Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M256.12,10.23V35.42h-9V23.29h-3.24V35.42h-9V10.23h9V21.64h3.24V10.23Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M272.89,19.08v2.84h8.46v1.66h-8.46v3H283.3v8.85H264V10.23H283.3v8.85Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M289.81,26.57c4.76,0,6.41-1.23,9.08-7.92,2.3-5.8,5.43-8.42,11.37-8.42h1.22V19h0c-2.81,0-3.82,2.56-5.29,6.63-2.45,6.73-7,9.75-14,9.75h-2.34Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
								</g>
							</motion.g>
						</g>
					</g>
					<g id="group_covid">
						<g clipPath="url(#clipPath-2)">
							<motion.g
								id="covid"
								className="isolation"
								variants={rightVar}
							>
								<g className="isolation">
									<path
										d="M6,93.92c0-20.73,14.4-34.84,35.51-34.84a35.59,35.59,0,0,1,21.22,7L50.11,87a13.2,13.2,0,0,0-8.54-3.17C35.43,83.84,31,88.06,31,93.73c0,6,4,10.08,10.46,10.08A14.31,14.31,0,0,0,51,100.35l11.71,21.12c-5.38,4.32-13.25,7.1-22.18,7.1C20.16,128.57,6,114.75,6,93.92Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M72.77,93.73c0-20,14.69-34.65,34.85-34.65,20,0,34.65,14.68,34.65,34.65,0,20.16-14.69,34.84-34.56,34.84C87.46,128.57,72.77,113.89,72.77,93.73Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M220.22,60.23,184.61,130.3,149,60.23Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M236.07,60.23h24v67.19h-24Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M281.19,60.23h11.32c8,0,39.74,0,39.74,33.4,0,33.79-29.47,33.79-35.8,33.79H281.19Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
								</g>
							</motion.g>
						</g>
					</g>
					<g id="group_testing">
						<g clipPath="url(#clipPath-3)">
							<motion.g
								id="testing-2"
								className="isolation"
								variants={leftVar}
							>
								<g className="isolation">
									<path
										d="M53.46,181.73H42.9v27.69H27.65V181.73H16.06v-15h37.4Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M79.93,181.73v4.82H94.26v2.8H79.93v5.07H97.56v15H64.92v-42.7H97.56v15Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M108.6,194.42c8.05,0,10.86-2.08,15.37-13.43,3.9-9.82,9.21-14.27,19.28-14.27h2.07v14.95h-.06c-4.76,0-6.47,4.33-9,11.22-4.15,11.41-11.77,16.53-23.73,16.53h-4Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M192.47,181.73H181.92v27.69H166.67V181.73H155.08v-15h37.39Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M203.94,166.72h15.25v42.7H203.94Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M269.88,166.72v42.7H232.61v-43.8l22,21.72V166.72Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M321.91,188.56v15.49c-3.84,3.72-10.18,6.1-17.08,6.1-14.46,0-23.67-8.41-23.67-21.41,0-13.54,10.19-22.75,24.53-22.75v22.57Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
								</g>
							</motion.g>
						</g>
					</g>
					<g id="group_lab">
						<g clipPath="url(#clipPath-4)">
							<motion.g
								id="lab"
								className="isolation"
								variants={rightVar}
							>
								<g className="isolation">
									<path
										d="M104.38,296.66v29.76H43.63v-84.7H73.88v54.94Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M167.9,238.09l44.89,88.33H123Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
									<path
										d="M298.33,303.07c0,23.35-20.44,23.35-36.78,23.35h-28.8v-84.7h25.53c15.49,0,35.58,0,35.58,20.81,0,9.2-5.21,16-13.19,18.15C290.83,283.22,298.33,291.69,298.33,303.07Z"
										transform="translate(-5.96 -9.15)"
										fill="currentColor"
									/>
								</g>
							</motion.g>
						</g>
					</g>
				</g>
			</motion.svg>
		</div>
   )
}